import { cva } from '@/styled-system/css';

export const comboboxTriggerRecipe = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: { base: 'Combobox.Trigger.bg.default' },
    boxShadow: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
    boxShadowColor: { base: 'Combobox.Trigger.border.default' },
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        'cursor': 'text',
        'backgroundColor': {
          _hover: 'Combobox.Trigger.bg.hover',
          _active: 'bg.neutral',
        },
        'boxShadowColor': {
          _hover: 'Combobox.Trigger.border.hover',
          _active: 'border.action.hero.selected.default',
        },

        '&:has(input:focus)': {
          backgroundColor: { base: 'bg.neutral' },
          boxShadow: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
          boxShadowColor: { base: 'border.action.hero.selected.default' },
        },
      },
    },
    error: {
      true: {
        backgroundColor: { base: 'Combobox.Trigger.bg.error' },
        boxShadowColor: { base: 'Combobox.Trigger.border.error' },
      },
      false: {},
    },
    readOnly: {
      true: {
        cursor: 'default',
        backgroundColor: { base: 'bg.invisible' },
        boxShadowColor: { base: 'border.invisible' },
      },
      false: {},
    },
    size: {
      sm: {
        borderRadius: 'obj.default',
        paddingBlock: 'tightest',
        paddingInline: 'default',
      },
      md: {
        borderRadius: 'obj.default',
        paddingBlock: 'tighter',
        paddingInline: 'default',
      },
      lg: {
        borderRadius: 'obj.default',
        paddingBlock: 'tight',
        paddingInline: 'default',
      },
    },
  },
  compoundVariants: [
    {
      size: 'sm',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      size: 'md',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      size: 'lg',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      disabled: false,
      error: true,
      css: {
        'backgroundColor': {
          _hover: 'Combobox.Trigger.bg.errorHover',
          _active: 'bg.neutral',
        },
        'boxShadowColor': {
          _active: 'Combobox.Trigger.border.errorActive',
          _hover: 'Combobox.Trigger.border.errorHover',
        },
        '&:is(:hover:active)': {
          backgroundColor: { base: 'Combobox.Trigger.bg.errorHover' },
        },
        '&:has(input:focus)': {
          backgroundColor: { base: 'bg.neutral' },
          boxShadowColor: { base: 'Combobox.Trigger.border.errorActive' },
        },
      },
    },
    {
      disabled: false,
      readOnly: true,
      css: {
        'backgroundColor': {
          _hover: 'bg.invisible',
          _active: 'bg.invisible',
        },
        'boxShadowColor': {
          _hover: 'border.invisible',
          _active: 'border.invisible',
        },
        '&:has(input:focus)': {
          backgroundColor: { base: 'bg.invisible' },
          boxShadow: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
          boxShadowColor: { base: 'border.invisible' },
        },
      },
    },
  ],
});
